import React, { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { api, ApiError } from "../../lib/api"
import { formatDateTime } from "../../lib/format"
import { AppShell } from "../ui/AppShell"
import { Button } from "../ui/Button"
import { Card } from "../ui/Card"
import { PageLoading } from "../ui/Spinner"
import { statusPill } from "./status"
import type { SupportTicketDetail, SupportTicketResponse } from "../../types"

export default function SuporteTicket() {
  const { id } = useParams<{ id: string }>()
  const [ticket, setTicket] = useState<SupportTicketDetail | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    api
      .get<SupportTicketResponse>(`/api/support_tickets/${id}`)
      .then((data) => setTicket(data.ticket))
      .catch((e: unknown) => setError(e instanceof ApiError ? e.message : "Erro ao carregar o chamado"))
  }, [id])

  if (error) {
    return (
      <AppShell>
        <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
          <p className="text-navy-700">{error}</p>
          <Link to="/suporte">
            <Button variant="secondary">Voltar</Button>
          </Link>
        </div>
      </AppShell>
    )
  }

  if (!ticket) {
    return (
      <AppShell>
        <PageLoading />
      </AppShell>
    )
  }

  return (
    <AppShell>
      <div className="flex flex-col gap-5">
        <div>
          <Link to="/suporte" className="text-sm font-medium text-gold-600 hover:text-gold-600">
            ← Suporte
          </Link>
          <div className="mt-2 flex flex-wrap items-start justify-between gap-3">
            <h1 className="text-2xl font-bold text-navy-900">{ticket.subject}</h1>
            {statusPill(ticket.status)}
          </div>
          <p className="mt-1 text-xs text-navy-400">Aberto em {formatDateTime(ticket.created_at)}</p>
        </div>

        <Card>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-navy-500">Sua mensagem</p>
          <p className="whitespace-pre-line text-sm leading-relaxed text-navy-800">{ticket.message}</p>
        </Card>

        {ticket.admin_response ? (
          <Card highlighted>
            <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-navy-500">
              Resposta do suporte
              {ticket.responded_at ? ` · ${formatDateTime(ticket.responded_at)}` : ""}
            </p>
            <p className="whitespace-pre-line text-sm leading-relaxed text-navy-800">{ticket.admin_response}</p>
          </Card>
        ) : (
          <Card className="text-center">
            <p className="text-sm text-navy-500">Aguardando resposta.</p>
            <p className="mt-1 text-xs text-navy-400">Assim que respondermos, você recebe um e-mail e vê aqui.</p>
          </Card>
        )}
      </div>
    </AppShell>
  )
}
